import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { RoleDTO } from 'src/app/models/RoleDTO.model';
import { UserManagementDTO } from 'src/app/models/UserManagementDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { RoleService } from 'src/app/services/role.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { emailValidator } from 'src/app/validators/email.validator';

import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-create-role',
    templateUrl: './create-role.component.html',
    styleUrl: './create-role.component.css',
    imports: [CommonModule, FormsModule]
})
export class CreateRoleComponent {
  title: string = 'Create Management Role';
  fieldsCompleted: boolean = false;

  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()]), 
  });

  get emailModel() {
    return this.form.get('email');
  }

  information: string = 'Information';
  roleName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  roleSelected: number = 0;
  states: MasterDataDTO[] = [];
  roles: RoleDTO[] = [];
  contactNumber?: string = undefined;
  email: string = '';
  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 1,
  };
  validMail: boolean = false;

  alert: Alert = {} as Alert;
  role: RoleDTO = {} as RoleDTO;
  isActive: boolean = false;

  constructor(
    private roleService: RoleService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.UserManagement);  // ToDo: ????  Это ошибка? может быть RoleManagement?
  }

  HandleGetRoles(roles: RoleDTO[]) {
    //console.log(roles);
    this.roles = roles;
  }

  handleGetAllStatesSuccess(states: MasterDataDTO[]) {
    this.states = states;
  }

  clearFields() {
    this.roleName = '';
    this.address = '';
    this.city = '';
    this.zipCode = undefined;
    this.stateSelected = '';
    this.contactNumber = undefined;
    this.email = '';
    this.roleSelected = 0;
  }

  createRole() {
    this.role.aRoleName = this.roleName;
    this.role.aRoleStatus = this.isActive ? 1 : 0;

    this.roleService.createRole(this.role).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleSaveSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
        this.clearFields();
      }
    );
  }

  checkFields() {
    if (
      this.roleName
    ) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }

  goBack() {
    window.location.href = '/role-management';
  }

  handleSaveError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
    this.clearFields();
  }

  async handleSaveSuccess(role: number) {
    if (role === 0) {
      this.alert = {
        alertMessage: 'This role already exists',
        alertType: 'alert alert-warning',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };

      this.alertService.updateAlertState(this.alert);
    } else {
      this.alert = {
        alertMessage: 'Role saved successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(this.alert);
      this.router.navigate(['/role-management']);
    }
  }

  checkEmailValidity() {
    const isValid = this.emailModel?.valid;
    if (isValid) {
      this.validMail = true;
    } else {
      this.validMail = false;
    }
    //console.log(this.validMail);
  }
}
